module.exports = "../static/media/banner_poster.4351b378.png";